import React, { useEffect, useState } from "react";
import ImageContainer from "../ImageContainer";
import { Link, useNavigate } from "react-router-dom";
import Linkify from "react-linkify";

import style from "./style.module.scss";
import Tag from "./components/Tag";
import { MDBIcon } from "mdb-react-ui-kit";
import { useDispatch } from "react-redux";
import { userClickLike } from "../../Containers/Client/action";
import PostOption from "./components/PostOption";
import {
	deleteCommentAction,
	deletePost,
} from "../../Containers/PostContainer/action";
import { toast } from "react-toastify";
import CommentForm from "../CommentForm";
import Comment from "../Comment/comment";
import { getTimestampFromNow } from "../../Utils/timeHelper";
import ProfilePicture from "../ProfilePicture";
import ShowMore from "react-show-more-text";

function Post({ data, loggedInUser }, key) {
	const { title, description, tags, creator, files, comments, createdAt } =
		data;

	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [likedBy, setLikedBy] = useState([]);
	const [isDescOpen, setIsDescOpen] = useState(false);
	let found;

	const [isLiked, setIsLiked] = useState();
	useEffect(() => {
		if (data.likedBy?.length > 0) {
			found = data.likedBy.filter((likers) => {
				return likers.username !== loggedInUser;
			});
			setLikedBy(found);
			setIsLiked(found.length !== data.likedBy.length);
		}
	}, []);
	const [isOpen, setIsOpen] = useState(false);
	const [onReply, setOnReply] = useState(false);

	const onClickRedirect = () => {
		if (loggedInUser === creator.username) {
			navigate("/");
		} else {
			navigate("/" + creator.username);
		}
	};
	const cbSuccessDeleteComment = () => {
		window.location.reload();
		toast.success("Comment Successfully Deleted!");
	};

	const onClickDeleteComment = (commentId) => {
		dispatch(deleteCommentAction(commentId, cbSuccessDeleteComment));
	};

	const renderTag = () => {
		if (tags?.length > 0) {
			return (
					<div className={style.tagContainer}>
						<b>Tags: </b>
						<div className={style.tags}>
							{tags.map((tag, index) => {
								return <Tag key={index} tag={tag} />;
							})}
						</div>
					</div>
			);
		}
		return "";
	};

	const onClickLike = () => {
		dispatch(userClickLike(data._id, isLiked));
		setIsLiked(!isLiked);
	};

	const getLikersPrefix = (index) =>{
		if (index === likedBy.length-1 && likedBy.length>1) {
			return " and ";
		}

		if (index !== 0) {
			return ", "
		}

		if (isLiked) return " and ";

	}

	const renderLikers = () => {
		if (likedBy?.length > 3) {
			return (
				<>
					{isLiked ? ", " : ""}
					<Link to={`/${likedBy[0].username}`} key={0}>
						{likedBy[0].username}
					</Link>
					{` and ${likedBy?.length - 1} others`}
				</>
			);
		}
		if (likedBy?.length > 0) {
			return (
				<>
					{likedBy.map((likers, index) => {
						return (
							<>
								{getLikersPrefix(index)}
								<Link to={`/${likers.username}`} key={index}>
									{likers.username}
								</Link>
							</>
						);
					})}
				</>
			);
		}
	};

	const renderLikes = () => {
		return (
			<>
				{isLiked ? "You" : ""}
				{renderLikers()}
				{likedBy?.length > 0 || isLiked ? " liked this mark!" : ""}
			</>
		);
	};

	const cbSuccessDelete = () => {
		toast.success("Mark Successfully Deleted!");
		window.location.reload();
	};

	const onClickDelete = () => {
		dispatch(deletePost(data._id, cbSuccessDelete));
	};

	return (
		<div className={style.postContainer} key={key}>
			<div className={style.topPost}>
				<div className={style.creator}>
					<div className={style.creatorPicture} onClick={onClickRedirect}>
						<ProfilePicture url={creator.profilePicture} isPost={true} />
					</div>
					<div className={style.creatorCreated}>
						<div className={style.nameHolder}>
							<div className={style.name} onClick={onClickRedirect}>
								{creator.name}
							</div>
							<div className={style.username}>{"@" + creator.username}</div>
						</div>
						<p>{getTimestampFromNow(createdAt)}</p>
					</div>
				</div>
				<div className={style.editParent}>
					<div className={style.edit} onClick={() => setIsOpen(!isOpen)}>
						<MDBIcon fas icon='ellipsis-v' />
					</div>
					{creator.username === loggedInUser ? (
						<PostOption isOpen={isOpen} onDelete={onClickDelete} />
					) : (
						""
					)}
				</div>
			</div>
			<div className={style.postContent}>
				<h4>{title}</h4>
				<Linkify
					componentDecorator={(decoratedHref, decoratedText, key) => (
						<a
							target='blank'
							className={style.link}
							href={decoratedHref}
							key={key}
						>
							{decoratedText}
						</a>
					)}
				>
					<div className={isDescOpen ? style.description : style.descNotOpen}>
						<ShowMore
							more='Show more'
							less='Show less'
							onClick={() => setIsDescOpen(!isDescOpen)}
							truncatedEndingComponent={"... "}
						>
							{description}
						</ShowMore>
					</div>
				</Linkify>
				<div className={style.imagePost}>
					{files.length > 0
						? files.map((url, index) => {
							return (
								<div className={style.imagePostContainer}>
										<ImageContainer
											url={url}
											key={index}
											isContentPost={true}
											/>
									</div>
								);
							})
							: ""}
				</div>
				{renderTag()}
				<div className={style.actionContainer}>
					<div className={style.likes}>
						<MDBIcon
							fas
							icon='heart'
							className={`me-1 pt-1 ${style.iconLike} ${
								isLiked ? style.liked : ""
							}`}
							onClick={onClickLike}
						/>{" "}
						{isLiked ? "Unlike " : "Like "}
						&bull;
					</div>
					<div
						onClick={() => setOnReply(!onReply)}
						className={style.replyAction}
					>
						<MDBIcon fas icon='comment' /> Reply
					</div>
				</div>
				<div className={style.likersName}>{renderLikes()}</div>
				<div className={style.commentContainer}>
					{comments.length > 0
						? comments.map((comment, index) => {
								return (
									<Comment
										data={comment}
										key={index}
										onClickRedirect={onClickRedirect}
										loggedInUser={loggedInUser}
										onClickDelete={onClickDeleteComment}
									/>
								);
						  })
						: null}
				</div>
				{onReply ? (
					<div className={style.comment}>
						<CommentForm
							parentId={data._id}
							isFromPost={true}
							active={onReply}
							setActive={setOnReply}
						/>
					</div>
				) : null}
			</div>
			{/* <div>
				
			</div> */}
		</div>
	);
}

export default Post;
